import { render, staticRenderFns } from "./DocumentDetailsComplete.vue?vue&type=template&id=511c2b90&scoped=true&"
import script from "./DocumentDetailsComplete.vue?vue&type=script&lang=js&"
export * from "./DocumentDetailsComplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "511c2b90",
  null
  
)

export default component.exports